import React from 'react';
import ReactDOM from 'react-dom';
 import Rofees from './Router/router';
  

ReactDOM.render(
  <React.StrictMode>
    <Rofees/>
  </React.StrictMode>,
  document.getElementById('Shinchan')
) 